/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePackagingReturnDto } from '../../models/create-packaging-return-dto';
import { PackagingReturn } from '../../models/packaging-return';

export interface PackagingReturnsControllerCreate$Params {
      body: CreatePackagingReturnDto
}

export function packagingReturnsControllerCreate(http: HttpClient, rootUrl: string, params: PackagingReturnsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingReturn>> {
  const rb = new RequestBuilder(rootUrl, packagingReturnsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingReturn>;
    })
  );
}

packagingReturnsControllerCreate.PATH = '/packaging-returns';
